export { GlobalNav } from "./nav-global";
export { ProductPageSubNav } from "./nav-product-page";
export {
    GlobalCompoundNav,
    CompoundSubNav
} from "./nav-global-compound-subnav";

export { GlobalNav as default } from "./nav-global";
